<pre>
	Text
	123
	{at}
	{slot}
</pre>

<script lang="ts">
    export let at: string
    export let slot: string

</script>
